import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import Paper from '@material-ui/core/Paper';
import deburr from 'lodash/deburr';

import InputField from './InputField';

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.label, query);
  const parts = parse(suggestion.label, matches);

  return (
    <MenuItem selected={isHighlighted} component="div">
      <div>
        {parts.map((part, index) =>
          part.highlight ? (
            <span key={String(index)} style={{ fontWeight: 600 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 300 }}>
              {part.text}
            </strong>
          )
        )}
      </div>
    </MenuItem>
  );
}

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

class IntegrationAutosuggest extends React.Component {
  constructor(props) {
    super(props);
    const { value } = this.props;

    this.state = {
      single: value || '',
      suggestions: []
    };
  }

  componentDidUpdate(prevProp) {
    const { value } = this.props;
    const { single } = this.state;
    if (prevProp.value !== value && value !== single) {
      // TODO: Figure this next issue out as it's a big code smell...
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ single: value });
    }
  }

  renderInputComponent = inputProps => {
    const { id, inputRef = () => {}, ref, errorMsg, ...other } = inputProps;
    return (
      <InputField
        id={id}
        {...other}
        useEvent
        error={errorMsg}
        InputProps={{
          inputRef: node => {
            ref(node);
            inputRef(node);
          }
        }}
      />
    );
  };

  handleSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  handleChange = name => (event, { newValue }) => {
    const { onChange } = this.props;
    this.setState({
      [name]: newValue
    });
    onChange({ key: null, label: newValue });
  };

  handleSuggestionSelected = (e, { suggestion }) => {
    const { onChange } = this.props;
    onChange(suggestion);
  };

  getSuggestions = value => {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;
    const { suggestions } = this.props;

    return inputLength === 0
      ? []
      : suggestions.filter(suggestion => {
          const keep = count < 5 && suggestion.label.toLowerCase().includes(inputValue);

          if (keep) {
            count += 1;
          }

          return keep;
        });
  };

  render() {
    const { placeholder } = this.props;
    // TODO: Look into why 'suggestions' is being set in state as it does not seem to be used...
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { single, suggestions } = this.state;
    const autosuggestProps = {
      renderInputComponent: this.renderInputComponent,
      suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue,
      renderSuggestion,
      onSuggestionSelected: this.handleSuggestionSelected
    };

    return (
      <div className="threepp-input-field-autocomplete">
        <Autosuggest
          {...autosuggestProps}
          inputProps={{
            ...this.props,
            placeholder,
            value: single,
            onChange: this.handleChange('single')
          }}
          theme={{ suggestionsContainer: 'suggestion-box', suggestionsList: 'suggestion-box-list' }}
          renderSuggestionsContainer={options => (
            <Paper {...options.containerProps} square>
              {options.children}
            </Paper>
          )}
        />
      </div>
    );
  }
}
export default IntegrationAutosuggest;
